import {ID, IModel} from '~/lib/model';
import {IBidderLite} from './BidderLite';

export interface IBidderGroup extends IModel {
    name: string;
    bidderIds: ID[];
    bidders?: IBidderLite[];
    ivtSensitive: boolean;
}

export const defaultBidderGroup: IBidderGroup = {
    id: null,
    name: '',
    bidderIds: [],
    bidders: [],
    ivtSensitive: false
};

export const IVT_SENSITIVE_HELP_TEXT = 'When enabled, this group is automatically disabled if IVT data cannot be reliably obtained — for example, due to a Redis, partner, or other infrastructure issue.';

export interface IBulkPauseResult {
    affected: number[];
    skipped: number[];
    notFound: number[];
}
